import type {
  ViewerDisplaySettings,
  ViewerListLayout,
  ViewerMapLanguage,
} from '../types/project';

/** Настройки отображения вьювера с заполненными дефолтами (см. ViewerDisplaySettings). */
export interface ResolvedViewerDisplaySettings {
  popupModals: boolean;
  /** 'auto' → подписи карты следуют языку интерфейса посетителя. */
  mapLanguage: ViewerMapLanguage;
  list: {
    layout: ViewerListLayout;
    /** null → «Описание» (свойство типа markdown); '' → строка скрыта. */
    primary: string | null;
    /** null/'' → второй строки нет. */
    secondary: string | null;
    showButtons: boolean;
  };
}

const LAYOUTS: ReadonlySet<string> = new Set(['medium', 'large', 'small', 'no-image']);
const MAP_LANGUAGES: ReadonlySet<string> = new Set(['auto', 'ru', 'en']);

/**
 * Дефолты «Настроек» вьювера: карты без настроек выглядят ровно как раньше
 * (medium-список с описанием, карточка справа, без кнопок).
 */
export function resolveViewerDisplaySettings(
  viewerDisplay: ViewerDisplaySettings | null | undefined,
): ResolvedViewerDisplaySettings {
  const list = viewerDisplay?.list;
  const layout =
    typeof list?.layout === 'string' && LAYOUTS.has(list.layout)
      ? (list.layout as ViewerListLayout)
      : 'medium';
  const mapLanguage =
    typeof viewerDisplay?.mapLanguage === 'string' && MAP_LANGUAGES.has(viewerDisplay.mapLanguage)
      ? viewerDisplay.mapLanguage
      : 'auto';
  return {
    popupModals: viewerDisplay?.popupModals === true,
    mapLanguage,
    list: {
      layout,
      primary: typeof list?.primary === 'string' ? list.primary : null,
      secondary:
        typeof list?.secondary === 'string' && list.secondary !== '' ? list.secondary : null,
      showButtons: list?.showButtons === true,
    },
  };
}
